module.exports = __webpack_public_path__ + "media/assets/mobile-nav-toggle-15a7459656c81a82acd2e36452ef81a9.svg";